var getScrollHeight = function () {
  return {
    left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
    top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
  }
}
var getScreen = function () {
  return {
    width: window.screen.width,
    height: window.screen.height
  }
}
// 判断是否是手机端
var _isMobile = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  if (flag) {
    console.log('移动端')
    return true
  } else {
    console.log('pc端')
    return false
  }
}
export default {
  getScrollHeight,
  getScreen,
  _isMobile
}



// WEBPACK FOOTER //
// ./src/utils/common.utils.js